/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MetadataSettableType } from '../../types';

type MetadataStateType = {
    metadataOrder: MetadataSettableType,
    metadataTenant: MetadataSettableType,
    fetchingForTenant: boolean,
    fetchingForOrder: boolean
};

const emptyMetada: MetadataSettableType = {
    vehicleTypes: [],
    equipment: [],
    sustainability: [],
    licencesCertificates: []
};

const initialState: MetadataStateType = {
    metadataOrder: emptyMetada,
    metadataTenant: emptyMetada,
    fetchingForTenant: false,
    fetchingForOrder: false
};

const slice = createSlice({
    name: 'metadata',
    initialState,
    reducers: {
        fetchForTenant: (state) => {
            state.fetchingForTenant = true;
        },
        fetchedForTenant: (state, action: PayloadAction<{ data: MetadataSettableType }>) => {
            state.metadataTenant = action.payload.data;
            state.fetchingForTenant = false;
        },
        fetchForOrder: (state) => {
            state.fetchingForOrder = true;
        },
        fetchedForOrder: (state, action: PayloadAction<{ data: MetadataSettableType }>) => {
            state.metadataOrder = action.payload.data;
            state.fetchingForOrder = false;
        }
    }
});

export default slice;
